import React__default from 'react';
import { EditorStack } from './EditorStack.js';

const EditorFieldGroup = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(EditorStack, { gap: 1 }, children);
};

export { EditorFieldGroup };
//# sourceMappingURL=EditorFieldGroup.js.map
